export default {
  path: 'vehicle-tags/:id',
  name: 'FleetTagView',
  component: () => import(/* webpackChunkName: "fleet" */ '../views/FleetTagView.vue')
}
